import React from 'react'
import { useTranslation } from 'react-i18next'
import { useCart } from '../../../contexts/CartContext'
import { useCategory } from '../../../contexts/CategoryContext'
import { Modal } from '../Modal'
import { Button } from '../Buttons'
import styled from 'styled-components'

const AlertWrapper = styled.div`
  padding: 10px 0 20px;
  text-align: center;
  line-height: 1.5;
`

export const VendorSwitchAlert = () => {
  const { t } = useTranslation()
  const [, { vendorSwitchAlert, dismissVendorSwitchAlert }] = useCart()
  const [categories] = useCategory()
  const currentLng = localStorage.getItem('i18nextLng')
  const clearedVendor = categories.find(v => v.id === vendorSwitchAlert?.clearedVendorId)
  const vendorName = clearedVendor
    ? (currentLng === 'en' ? clearedVendor.name_en : clearedVendor.name_ar)
    : ''

  return (
    <Modal
      open={Boolean(vendorSwitchAlert?.clearedVendorId)}
      onClose={dismissVendorSwitchAlert}
      width="400px"
      isHideCloseIcon
    >
      <AlertWrapper>
        {t('Vendor Switch Cart Alert').replace('_vendor_', vendorName)}
      </AlertWrapper>
      <Button color="primary" width="100%" onClick={dismissVendorSwitchAlert}>
        {t('Ok')}
      </Button>
    </Modal>
  )
}
